(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-pop-up-explainer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const toggle = document.querySelector('.lgx-pop-up-explainer-toggle');
    const modal = document.querySelector('.lgx-pop-up-explainer-modal');
    const closeButton = document.querySelector('.lgx-pop-up-explainer-close');
    const overlay = document.querySelector('.lgx-pop-up-explainer-overlay');

    // Move the modal element to the end of the body to help with z-index stacking issues
    if (modal) {
      document.body.appendChild(modal);
    }

    function openModal() {
      modal.style.display = 'flex';
    }

    function closeModal() {
      modal.style.display = 'none';
    }

    toggle.addEventListener('click', openModal);
    closeButton.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);

    // Close modal with Escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
